import React, { useEffect, useRef, useState } from "react";
import { Button, Input, Modal } from "antd";
import { MfaPromptOptions, setMfaPromptHandler } from "../../services/mfaPrompt";

// "Enter your authenticator code" popup for two-factor sign-in. Mounted once in App.tsx.
const MfaPromptHost = () => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | undefined>();
  const [useRecovery, setUseRecovery] = useState(false);
  const resolver = useRef<((value: string | null) => void) | null>(null);

  useEffect(() => {
    setMfaPromptHandler((options: MfaPromptOptions) => {
      resolver.current?.(null);
      return new Promise((resolve) => {
        resolver.current = resolve;
        setCode("");
        setError(options.error);
        setOpen(true);
      });
    });
    return () => setMfaPromptHandler(null);
  }, []);

  const finish = (value: string | null) => {
    setOpen(false);
    resolver.current?.(value);
    resolver.current = null;
  };

  const cleaned = useRecovery ? code.trim().toUpperCase() : code.replace(/\D/g, "");
  const canSubmit = useRecovery ? cleaned.replace(/[^A-Z0-9]/g, "").length === 10 : cleaned.length === 6;

  return (
    <Modal
      open={open}
      title="Enter your code"
      onCancel={() => finish(null)}
      maskClosable={false}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={() => finish(null)}>
          Cancel
        </Button>,
        <Button key="verify" type="primary" disabled={!canSubmit} onClick={() => finish(cleaned)}>
          Verify
        </Button>,
      ]}
    >
      <p>
        {useRecovery
          ? "Enter one of the recovery codes you saved when you turned on two-factor."
          : "Open your authenticator app and enter the 6-digit code for Indexx."}
      </p>
      <Input
        autoFocus
        size="large"
        value={code}
        onChange={(event) => setCode(event.target.value)}
        onPressEnter={() => canSubmit && finish(cleaned)}
        inputMode={useRecovery ? "text" : "numeric"}
        autoComplete="one-time-code"
        maxLength={useRecovery ? 11 : 6}
        placeholder={useRecovery ? "XXXXX-XXXXX" : "123456"}
        style={{ textAlign: "center", letterSpacing: 6, fontSize: 22 }}
      />
      {error ? <p style={{ color: "#e5484d", marginTop: 10 }}>{error}</p> : null}
      <Button
        type="link"
        style={{ paddingLeft: 0, marginTop: 8 }}
        onClick={() => {
          setUseRecovery(!useRecovery);
          setCode("");
        }}
      >
        {useRecovery ? "Use my authenticator app instead" : "Use a recovery code instead"}
      </Button>
    </Modal>
  );
};

export default MfaPromptHost;
